<template>
  <v-container>
    <v-row>
      <v-col
        md="6"
        cols="12"
      >
        <material-card
          icon="mdi-account-reactivate"
          title="Integração de cadastro"
          color="#003677"
        >
          <v-col
            cols="12"
          >
            <v-simple-table
              height="464px"
            >
              <thead>
                <tr>
                  <th
                    width="35%"
                    class="text-left"
                  >
                    Integração
                  </th>
                  <th
                    class="text-center"
                  >
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Cadastro de Associados
                  </td>
                  <td
                    class="text-right"
                    style="padding: 10px;"
                  >
                    <planilha-upload-dialog
                      :disabled="!$store.getters.hasPermission('inserir_associado')"
                      :template-id="3"
                      small
                      color="primary"
                    />
                    <v-btn
                      :disabled="!$store.getters.hasPermission('inserir_associado')"
                      href="/Modelo-importacao/modelo-associado.xlsx"
                      target="_blank"
                      class="white--text my-1 text-none"
                      color="primary"
                      small
                      title="Modelo da planilha"
                      rounded
                      style="margin: 2px;"
                    >
                      <v-icon
                        left
                      >
                        mdi-table
                      </v-icon>
                      <span class="mr-1">
                        Modelo
                      </span>
                    </v-btn>
                    <integracao-dialog-log
                      :template-id="3"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    Cadastro de Unidade Negócio
                  </td>
                  <td
                    class="text-right"
                    style="padding: 10px;"
                  >
                    <planilha-upload-dialog
                      :disabled="!$store.getters.hasPermission('inserir_unidade_negocio')"
                      :template-id="4"
                      small
                      color="primary"
                    />
                    <v-btn
                      :disabled="!$store.getters.hasPermission('inserir_unidade_negocio')"
                      href="/Modelo-importacao/modelo-unidade-negocio.xlsx"
                      target="_blank"
                      class="white--text my-1 text-none"
                      color="primary"
                      small
                      title="Modelo da planilha"
                      rounded
                      style="margin: 2px;"
                    >
                      <v-icon
                        left
                      >
                        mdi-table
                      </v-icon>
                      <span class="mr-1">
                        Modelo
                      </span>
                    </v-btn>
                    <integracao-dialog-log
                      :template-id="4"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    Cadastro de Fornecedores
                  </td>
                  <td
                    class="text-right"
                    style="padding: 10px;"
                  >
                    <planilha-upload-dialog
                      :disabled="!$store.getters.hasPermission('inserir_fornecedor')"
                      :template-id="5"
                      small
                      color="primary"
                    />
                    <v-btn
                      :disabled="!$store.getters.hasPermission('inserir_fornecedor')"
                      href="/Modelo-importacao/modelo-fornecedor.xlsx"
                      target="_blank"
                      class="white--text my-1 text-none"
                      color="primary"
                      small
                      title="Modelo da planilha"
                      rounded
                      style="margin: 2px;"
                    >
                      <v-icon
                        dark
                        left
                      >
                        mdi-table
                      </v-icon>
                      <span class="mr-1">
                        Modelo
                      </span>
                    </v-btn>
                    <integracao-dialog-log
                      :template-id="5"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </material-card>
      </v-col>
      <v-col
        md="6"
        cols="12"
      >
        <material-card
          icon="mdi-account-convert-outline"
          title="Integração das movimentações"
          color="#003677"
        >
          <v-col
            cols="12"
          >
            <v-simple-table
              height="464px"
            >
              <thead>
                <tr>
                  <th
                    class="text-left"
                    width="35%"
                  >
                    Integração
                  </th>
                  <th
                    class="text-center"
                  >
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Lançamento de Faturamento
                  </td>
                  <td
                    class="text-right"
                    style="padding: 10px;"
                  >
                    <planilha-upload-dialog
                      :disabled="!$store.getters.hasPermission('inserir_lancamento_faturamento')"
                      :template-id="6"
                      small
                      color="primary"
                    />
                    <v-btn
                      :disabled="!$store.getters.hasPermission('inserir_lancamento_faturamento')"
                      href="/Modelo-importacao/modelo-lancamento-faturamento.xlsx"
                      target="_blank"
                      class="white--text my-1 text-none"
                      color="primary"
                      small
                      title="Modelo da planilha"
                      rounded
                      style="margin: 2px;"
                    >
                      <v-icon
                        dark
                        left
                      >
                        mdi-table
                      </v-icon>
                      <span class="mr-1">
                        Modelo
                      </span>
                    </v-btn>
                    <integracao-dialog-log
                      :template-id="6"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import PlanilhaUploadDialog from '../../components/PlanillhaUpload'
  import MaterialCard from '../../components/base/MaterialCard'
  import IntegracaoDialogLog from './IntegracaoDialogLog.vue'
  import api from '@/api/api'

  export default {
    name: 'Integracao',
    components: {
      PlanilhaUploadDialog,
      MaterialCard,
      IntegracaoDialogLog,
    },
    data () {
      return {
        api,
      }
    },
    methods: {
      postPdf (pdf) {
        const postPdf = new FormData()
        postPdf.append('pdf', pdf)
        return this.api.sendFileFormData(postPdf, 'extrato/batch')
      },
    },
  }
</script>
